export default [
  {
    path: "/activity"
    // component: () => import("@views/home/index.vue")
  },
  {
    path: "/activity/goods_seckill",
    name: "GoodsSeckill",
    meta: {
      title: "限时抢购",
      keepAlive: false,
      backgroundColor: "#ffffff"
    },
    component: () => import("@views/activity/GoodsSeckill.vue")
  },
  {
    path: "/activity/seckill_detail/:id?/:time?/:status?",
    name: "SeckillDetails",
    meta: {
      title: "抢购详情页",
      keepAlive: true
    },
    component: () => import("@views/activity/SeckillDetails.vue")
  },
  {
    path: "/activity/lottery",
    name: "Lottery",
    meta: {
      title: "抽奖",
      keepAlive: true
    },
    component: () => import("@views/activity/Lottery.vue")
  },
  {
    path: "/activity/goods_bargain",
    name: "GoodsBargain",
    meta: {
      title: "砍价活动",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/activity/GoodsBargain.vue")
  },
  {
    path: "/activity/goods_bargain_details/:id?/:bargain?",
    name: "GoodsBargainDetails",
    meta: {
      title: "砍价活动详情",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/activity/GoodsBargainDetails.vue")
  },
  {
    path: "/activity/user_goods_bargain_list",
    name: "UserGoodsBargainList",
    meta: {
      title: "用户砍价列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/activity/UserGoodsBargainList.vue")
  },
  {
    path: "/activity/goods_combination",
    name: "GoodsCombination",
    meta: {
      title: "拼团活动",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/activity/GoodsCombination.vue")
  },
  {
    path: "/activity/goods_combination_details/:id?",
    name: "GoodsCombinationDetails",
    meta: {
      title: "拼团详情",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/activity/GoodsCombinationDetails.vue")
  },
  {
    path: "/activity/goods_combination_status/:id?",
    name: "GoodsCombinationStatus",
    meta: {
      title: "拼团状态",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/activity/GoodsCombinationStatus.vue")
  },
  {
    path: "/activity/presell_list",
    name: "PresellList",
    meta: {
      title: "预售活动",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/activity/PresellList.vue")
  },
  {
    path: "/activity/presell_details/:id",
    name: "PresellDetails",
    meta: {
      title: "预售详情",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/activity/PresellDetails.vue")
  },
];
